import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Address } from '@apaq/orgkit-js';

@Component({
  selector: 'ws-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: AddressInputComponent, multi: true }]
})
export class AddressInputComponent implements ControlValueAccessor {

  @Input() label?: string;
  @Input() readonly = false;
  address?: Address;
  _street: string = '';
  _apartment: string = ''
  _postalCode: string = '';
  _city: string = '';
  _countryCode: string = '';
  disabled = false;
  onChange?: (value: Address) => void;
  onTouched?: () => void;
  

  constructor() { }
  writeValue(address: Address): void {
    this.address = address;
    this.street = address?.street;
    this.apartment = address?.apartment;
    this.postalCode = address?.postalCode;
    this.city = address?.city;
    this.countryCode = address?.countryCode;
  }

  get street() {
    return this._street;
  }

  set street(value: string) {
    this._street = value ?? null;
    this.emitChange();
  }

  get apartment() {
    return this._apartment;
  }

  set apartment(value: string) {
    this._apartment = value ?? null;
    this.emitChange();
  }

  get postalCode() {
    return this._postalCode;
  }

  set postalCode(value: string) {
    this._postalCode = value ?? null;
    this.emitChange();
  }

  get city() {
    return this._city;
  }

  set city(value: string) {
    this._city = value ?? null;
    this.emitChange();
  }
  
  get countryCode() {
    return this._countryCode;
  }

  set countryCode(value: string) {
    this._countryCode = value ?? null;
    this.emitChange();
  }

  @HostListener('slBlur', ['$event'])
  handleBlur(_: CustomEvent) {
    if(this.onTouched) {
      this.onTouched();
    }
  }
  
  
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private emitChange() {
    if(this.onChange) {
      const address: Address = {
        street: this.street ?? null,
        apartment: this.apartment ?? null,
        postalCode: this.postalCode ?? null,
        city: this.city ?? null,
        countryCode: this.countryCode ?? null
      }
      this.onChange(address);
    }
  }

}
